<template>
  <Layout>
    <PageHeader
      :title="title"
      :subTitle="subTitle"
      :items="breadcrumbItems"
      hasBreadcrumb
      hasBackButton
    />

    <b-tabs v-model="tabIndex">
      <b-tab v-for="tab in tabs" :key="tab.key" :title="tab.title" />
    </b-tabs>

    <b-card>
      <component :is="activeTab.component" v-if="activeTab" />
    </b-card>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2.vue'
import CancelReason from './components/CancelReason'
import AutoComplete from './components/AutoComplete'
import BufferTime from './components/BufferTime'
import AutoEndedQuickAssignment from './components/AutoEndedQuickAssignment'
import * as Setting from '@/services/rest-api/lib/fleet-task/setting'
import { computed } from 'vue'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'

export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    CancelReason,
    AutoComplete,
    BufferTime,
    AutoEndedQuickAssignment,
  },
  provide() {
    return {
      setting: computed(() => this.setting),
      getUserSetting: computed(() => this.getUserSetting),
    }
  },
  mixins: [Helper],
  data() {
    return {
      tabIndex: 0,
      setting: null,
    }
  },
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    title() {
      return this.$t('setting.homePage.fleetTask')
    },
    subTitle() {
      return this.$t('setting.homePage.textFleetTask')
    },
    tabs() {
      const tabs = [
        {
          key: 'cancel-reason',
          title: this.$t('setting.reasonCancel.label'),
          component: CancelReason,
        },
      ]

      if (this.hasAccessAutocomplete) {
        tabs.push({
          key: 'auto-complete',
          title: this.$t('setting.autoComplete.tab'),
          component: AutoComplete,
        })
      }

      if (this.hasFeatureBufferTimeMGM) {
        tabs.push({
          key: 'buffer-time',
          title: this.$t('setting.bufferTime.label'),
          component: BufferTime,
        })
      }

      if (this.hasAutoEndedQuickAssignment) {
        tabs.push({
          key: 'auto-ended-quick-assignment',
          title: this.$t('fleetTaskInstant.autoEndedQuickAssigment.label'),
          component: AutoEndedQuickAssignment,
        })
      }

      return tabs
    },
    activeTab() {
      return this.tabs[this.tabIndex] ?? this.tabs[0] ?? null
    },
    hasAccessAutocomplete() {
      return this.hasAccessAll([
        'tms-gps-autocomplete:create',
        'tms-gps-autocomplete:read',
        'tms-gps-autocomplete:update',
        'tms-gps-autocomplete:delete',
      ])
    },
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.list.fleetTaskSetting.setting'),
          to: '/setting',
        },
        {
          text: this.$t('setting.list.fleetTaskSetting.fleetTask'),
        },
      ]
    },
    hasFeatureBufferTimeMGM() {
      const data = this.getFeatureFlagValue('customFeature.mgm')
      return (
        Array.isArray(data?.company_id) &&
        data.company_id.includes(this.getCompanyId()) &&
        data?.features?.buffer_time
      )
    },
    hasAutoEndedQuickAssignment() {
      const data = this.getFeatureFlagValue('customFeature.UnfinishedQA')
      return (
        Array.isArray(data?.company_id) &&
        data.company_id.includes(this.getCompanyId())
      )
    },
  },
  mounted() {
    this.getUserSetting()
  },
  methods: {
    async getUserSetting() {
      const res = await Setting.get()

      if (res.errors) return

      this.setting = res.data
    },
  },
}
</script>
